import { LinkButton, ResponsiveImage } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import { maxWidth } from '@sleepstation/style-api-helpers'
import { classStartsWith } from '@sleepstation/style-mixins'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import BreakoutModuleNarrow from '../../../shared/breakoutModules/BreakoutModuleNarrow'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const IMAGE_ASPECT_RATIO = 1

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [1, 2],
  align: LAYOUT_ALIGN.CENTER,
})``

const Header = styled.header`
  width: 100%;
  ${maxWidth([4, 5, 6])}
`

const Body = styled(VLayout).attrs({
  spacing: 1,
  align: LAYOUT_ALIGN.CENTER,
})`
  ${maxWidth(20)}

  > ${classStartsWith(`LinkButton_`)} {
    max-width: ${rem(300)};
    width: 100%;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackThankYouPage = ({ content }) => (
  <BreakoutModuleNarrow
    hasGradient={false}
    hasBottomBorder={false}
    paddingV={[1, 2, [2.25, 3]]}
  >
    <Layout>
      <Header>
        <ResponsiveImage
          aspectRatio={IMAGE_ASPECT_RATIO}
          src={content.illustration.url}
          alt={content.illustration.alt}
        />
      </Header>
      <Body>
        <CopyParagraph>{content.ody}</CopyParagraph>
        <LinkButton
          href={content.backToDashboardLink.path}
          forceOpenInSameWindow
          data-cy="back-to-dashboard-link"
        >
          {content.backToDashboardLink.title}
        </LinkButton>
      </Body>
    </Layout>
  </BreakoutModuleNarrow>
)

FeedbackThankYouPage.propTypes = {
  content: PropTypes.object.isRequired,
}

export default FeedbackThankYouPage
